import styled from 'styled-components';
import { beam } from '@styles/colors/themes';

export const StyledText = styled.text`
  color: ${beam.font.primary};
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 18px;
`;

export const User = styled.div`
  display: flex;
  align-items: center;
`;

export const Line = styled.div`
  height: 0;
  width: 100%;
  margin-top: 9px;

  /* borders/default-border */
  border: 1px solid #e9edf1;
`;
export const ProductDiv = styled.div`
  height: 68px;
  width: 100%;
  /* neutral tones/default-white */
  background: #ffffff;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 8px;
  /* new--shadow */
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.161);
  border-radius: 8px;
  margin-bottom: 16px;
`;
export const RowDiv = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
`;
export const ProductHeader = styled.div`
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 18px;
  margin-left: 0;
  margin-bottom: 4px;
  /* identical to box height */

  /* beam texts/text-blueish-gray */
  color: #758ca3;
`;
export const ColumnDiv = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  font-weight: 500;

  &.header {
    font-size: 18px;
  }
`;
export const LinkText = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  cursor: pointer;
  text-decoration-line: underline;
  font-weight: 500;
  font-size: 14px;
  line-height: 21px;
  color: #1371fe;
`;
export const FindButton = styled.button`
  font-style: normal;
  white-space: nowrap;
  cursor: pointer;
  border: none;
  font-weight: 500;
  font-size: 14px;
  /* identical to box height */
  margin-left: 16px;
  /* neutral tones/default-white */
  color: #ffffff;

  /* Inside Auto Layout */
  flex: none;
  order: 0;
  flex-grow: 0;

  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 8px 16px 7px;

  width: 66px;
  height: 36px;
  align-self: center;
  justify-self: flex-end;
  background: linear-gradient(90deg, #4992ff 0%, #2bc5e7 100%);
  border-radius: 8px;
  :disabled {
    opacity: 0.3;
    cursor: auto;
  }
`;
interface IBody {
  width: number;
  isToggle?: boolean;
}
export const Td = styled.div<IBody>`
  width: ${({ width }) => width}%;
  max-width: ${({ width }) => width}%;
  border: solid 0 transparent;
  height: 48px;
  padding: 0 8px;
  //background: #fff;
  color: #1a1b1c;
  font-size: 16px;
  font-weight: 400;
  align-items: center;
  text-align: start;
  flex-direction: row;
  white-space: nowrap;
  overflow: hidden;
  position: relative;
  display: flex;

  &:first-child {
    border-left-style: solid;
    border-top-left-radius: 8px;
    padding-left: 0;
    margin-left: 0;
    border-bottom-left-radius: 8px;
    position: ${({ isToggle }) => (isToggle ? 'unset' : 'relative')};
  }

  &:last-child {
    border-right-style: solid;
    border-bottom-right-radius: 8px;
    border-top-right-radius: 8px;
  }

  :after {
    content: '';
    width: 40px;
    border-bottom-right-radius: 8px;
    border-top-right-radius: 8px;
    right: 0;
    position: absolute;
    background: -webkit-linear-gradient(
      left,
      rgba(255, 255, 255, 0) 70%,
      #fff 95%
    );
    height: 48px;
    z-index: 4;
  }
`;
export const ScrollDiv = styled.div`
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  height: 100%;
  padding: 1px;
  width: 100%;
`;
export const TextMatches = styled.div`
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  margin-bottom: 16px;
  /* identical to box height */

  /* beam texts/text-blueish-gray */
  color: #758ca3;
`;
